import * as React from 'react'
import './Layout.scss'
import { scrollToTop } from '../../common/helpers/scroll'

export interface ILayoutProps {
  header: React.ReactNode | React.ReactNode[]
  children: React.ReactNode | React.ReactNode[]
  isNarrow: boolean
}

export class Layout extends React.Component<ILayoutProps> {
  layoutContentBEM() {
    const classArray = ['layout__content', 'scrollable']

    /*if (this.props.isNarrow) {
      classArray.push('layout__content--narrow')
    }*/

    return classArray.join(' ')
  }

  scrollToTop = (event: { target: any; currentTarget: any }) => {
    if (['nav', 'layout__header'].includes(event.target.className)) scrollToTop()
  }

  render() {
    const { children, header } = this.props

    return (
      <div className="layout">
        <div className="layout__inner">
          <div className="layout__header" onClick={this.scrollToTop}>
            {header}
          </div>
          <div id="content" className={this.layoutContentBEM()}>
            {children}
          </div>
        </div>
      </div>
    )
  }
}
